import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Typography from '@visa/vds/typography';
import Grid from '@visa/vds/grid';
import Row from '@visa/vds/row';
import Col from '@visa/vds/col';
import BillingLineTable from './BillingLineTable';
import MCSSpace from '../../../components/MCSSpace';
import { AdminRoutes } from '../../../_constants/PageRoutes';
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import { GlobalAlertContext } from '../../../context/GlobalAlertContext';

function ManageBillingLines() {
    const [isLoaded1, setIsLoaded1] = useState(false);
    // const [isLoaded2, setIsLoaded2] = useState(false);

    const history = useHistory();

    const manageBillingLine = (item) => {
        history.push({
            pathname: AdminRoutes.MANAGEBILLINGLINES_DETAILS,
            state: {
                billingLine: item
            }
        })
    }

    return (
        <>
            {/*{ (!isLoaded1 || !isLoaded2) && <MCSOverlayLoading></MCSOverlayLoading>}*/}
            {!isLoaded1 && <MCSOverlayLoading></MCSOverlayLoading>}
            <GlobalAlertContext.Consumer>
                {
                    alertObj => (
                        <Grid>
                            <Row>
                                <Col>
                                    <Typography tag="h1">Manage Billing Lines</Typography>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Typography tag="h2">VISA SECURE TEST SUITE (VSTS)</Typography>
                                </Col>
                                <BillingLineTable productCategoryId="1" showCustomDescription={true} manageBillingLine={manageBillingLine} isLoaded={setIsLoaded1} />
                            </Row>
                            <MCSSpace />
                            {/*<Row>
                                <Col>
                                    <Typography tag="h2">VISA SECURE FOR EMV 3DS TESTING (VSTT)</Typography>
                                </Col>
                                <BillingLineTable productCategoryId="2" showCustomDescription={false} manageBillingLine={manageBillingLine} isLoaded={setIsLoaded2} />
                            </Row>*/}
                        </Grid>
                    )
                }
            </GlobalAlertContext.Consumer>
        </>
    );
}

export default ManageBillingLines;